const pugpigInApp = function() {
  return window.location.protocol.search(/http(s)?/) === -1;
}

const PugpigSitePiano = () => {

  tp = window['tp'] || []

  // Read id domain metadata from the head to allow id domain to be set
  var idDomainMeta = document.querySelector("meta[property='pugpig:piano:iddomain']");
  if (idDomainMeta) {
    var idDomainValue = idDomainMeta.getAttribute('content');
    console.log('%cPugpig Piano ID Domain set', 'background: #222; color: #bada55', 'ID Domain: ' + idDomainMeta.getAttribute('content'));
    tp.push(['setPianoIdUrl',idDomainValue]);
  }

  // Information on the cookies here:
  // https://docs.piano.io/piano-cookie-descriptions/
  tp.push(["setMaxCookieExpirationInDays", 365]);

  // Callbacks here: https://docs.piano.io/callbacks/
  // tp.push(["addHandler", "registrationSuccess", onRegistrationSuccess]);
  tp.push(["addHandler", "showOffer", onShowOffer]);
  tp.push(["addHandler", "checkoutComplete", onCheckoutComplete]);
  tp.push(["addHandler", "checkoutClosed", onCheckoutClosed]);
  tp.push(["addHandler", "checkoutSelectTerm", onCheckoutSelectTerm]);
  tp.push(["addHandler", "checkoutStateChange", onCheckoutStateChange]);
  tp.push(["addHandler", "startCheckout", onStartCheckout]);
  tp.push(["addHandler", "submitPayment", onSubmitPayment]);

/* user login events */
  // tp.push(["addHandler", "loginRequired", onLoginRequired]);
  tp.push(["addHandler", "loginSuccess", setUserState]);
  tp.push(["addHandler", "loginFailed", setUserState]);

  // Increases verbosity of debug messages
  // tp.push(["setSandbox", true]);
  // tp.push(["setDebug", true]);

  tp.push(['init', pugpigInit]);

// TP: Parameter formName is required to log impression.

  sendPianoData();

  setupMeters();

  function pushEventToDataLayer(eventName, data) {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({event: 'piano_' + eventName, data: data});
    }
  }

  function crossLinkGA() {
    // https://docs.piano.io/integrating-with-google-analytics/
    // This MUST include the correct GA ID
    // An item gaCrossDomainLinkingID must be pushed to the Data Layer via GTM or Site
    /*
      dataLayer.push({'gaCrossDomainLinkingID':'UA-XXXXXXX-XX'});
    */

    if (typeof window.gaCrossDomainLinkingID === 'undefined') {
      if (typeof dataLayer !== 'undefined') {
        var el = dataLayer.find(element => element.gaCrossDomainLinkingID !== 'undefined');
        var gaCrossDomainLinkingID = el.gaCrossDomainLinkingID;
        console.log('%cPugpig Piano GA Cross Domain Linking', 'background: #222; color: #bada55', '(From data layer)', gaCrossDomainLinkingID);
      }
    } else {
      var gaCrossDomainLinkingID  = window.gaCrossDomainLinkingID;
      console.log('%cPugpig Piano GA Cross Domain Linking', 'background: #222; color: #bada55', '(From settings)', gaCrossDomainLinkingID);
    }

    if (typeof gaCrossDomainLinkingID !== 'undefined') {
      tp.enableGACrossDomainLinking(gaCrossDomainLinkingID);
      if (tp.gaClientId) {
        console.log('%cPugpig Piano GA Cross Domain Linking', 'background: #222; color: green', 'Successfully linked', tp.gaClientId);
      } else {
        console.log('%cPugpig Piano GA Cross Domain Linking', 'background: #222; color: red', "Failed to link");
      }
    } else {
        console.log('%cPugpig Piano GA Cross Domain Linking', 'background: #222; color: orange', "No gaCrossDomainLinkingID found");
    }
  }

  function pugpigInit() {

    crossLinkGA();

    attachEventListeners();
    tp.pianoId.registerCallback('extendedUserLoaded', function (user) {
      console.log('%cPugpig Piano User', 'background: #222; color: #cccccc', user);
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({'piano_user': user});
        dataLayer.push({event: 'piano_user_updated'});
      }

      // This is needed for triggering third party code such as Hyvor or Podcast.co
      var event = new CustomEvent("PianoUserLoaded", {
        detail: {
          user: user
        }
      });
      window.dispatchEvent(event);

      /*
      var userCustomDimensions = user;
      // In future we should consider named items/data-attributes/etc for showing custom fields
      var element = document.querySelector('#pp-firstname');
      if (element) {
        element.innerText = userCustomDimensions.first_name + " " + userCustomDimensions.last_name;
      }
      */
    })

    if (!tp.pianoId.isUserValid() && fetchTokenFromQuery()) {
      tp.pianoId.loginByToken(fetchTokenFromQuery());
    }

    document.addEventListener("DOMContentLoaded", setUserState)

    if (['complete', 'interactive', 'loaded'].includes(document.readyState)) {
        setUserState()
    }

    // Check access:
    // https://docs.piano.io/checking-access/#check-access-js
  }

  function fetchTokenFromQuery() {
    let paramsString = window.location.search
    let searchParams = new URLSearchParams(paramsString)
    let token = searchParams.get("token")
    return token
  }

  function sendPianoData() {
    // If the content is native advertising
    tp.push(["setContentIsNative", false]);

    // The AAM Zone
    tp.push(["setZone", "Web"]);

    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'Loaded Piano object');

    // Read some metadata from the head and send it to Piano so it can use it in an experience
    var accessMeta = document.querySelector("meta[property='pugpig:access']");
    if (accessMeta) {
      var accessValue = accessMeta.getAttribute('content');
      console.log('%cPugpig Piano setCustomVariable', 'background: #222; color: #bada55', 'PageAccess: ' + accessMeta.getAttribute('content'));
      tp.push(["setCustomVariable", "PageAccess", accessValue]);
    }

    // Push tags
    // Test via tp.tags
    var accessTagsMeta = document.querySelectorAll("meta[property='pugpig:tag']");
    if (accessTagsMeta && accessTagsMeta.length > 0) {
      var tags = [];
      accessTagsMeta.forEach(item => {
        tags.push(item.getAttribute('content'));
      })
      if (tags) {
        tp.push(["setTags", tags]);
        console.log('%cPugpig Piano setCustomTag', 'background: #222; color: #bada55', tags);
      }
    }

   // Push custom variables
   // Test via tp.customVariables
   var accessVariablessMeta = document.querySelectorAll("meta[property='pugpig:access:variables']");
   if (accessVariablessMeta && accessVariablessMeta.length > 0) {
        accessVariablessMeta.forEach(item => {
            var n = item.getAttribute('name');
            var c = item.getAttribute('content');
            if (n && c) {
              tp.push(["setCustomVariable", n, c]);
              console.log('%cPugpig Piano setCustomVariable', 'background: #222; color: #bada55', n + ': ' + c);
            }
        })
    }

  // Push author meta
  // Note that only one author can be passed for each page – arrays are not permitted.
   var accessAuthorMeta = document.querySelector("meta[name='author']");
    if (accessAuthorMeta) {
      var accessAuthorValue = accessAuthorMeta.getAttribute('content');
      console.log('%cPugpig Piano setContentAuthor', 'background: #222; color: #bada55', 'Author: ' + accessAuthorMeta.getAttribute('content'));
      tp.push(["setContentAuthor", accessAuthorValue]);
    }

    // Push section meta
    var accessSectionMeta = document.querySelector("meta[name='section']");
    if (accessSectionMeta) {
      var accessSectionValue = accessSectionMeta.getAttribute('content');
      console.log('%cPugpig Piano setContentSection', 'background: #222; color: #bada55', 'Section: ' + accessSectionMeta.getAttribute('content'));
      tp.push(["setContentSection", accessSectionValue]);
    }
  }

  function setupMeters() {
    // Docs here:
    // https://docs.piano.io/callbacks/#activeevent
    tp.push(["addHandler", "meterActive", function(meterData) {

      setUserAccess(true);
      console.log('%cPugpig Piano Allow Access', 'background: #222; color: #cccccc', "Meter" + name);

       var message = "You've seen " + meterData.views
             + " out of " + meterData.maxViews
             + " free articles. You have " + meterData.viewsLeft
             + " articles left.";
        console.log('%cPugpig Piano Meter', 'background: #222; color: #cccccc', message);

       var element = document.querySelector('#pp-subs-meter-active')

       if (element) {
         element.innerText = message;
        }
    }]);

    tp.push(["addHandler", "meterExpired", function(meterData){
       var message = "Bad news! You've seen " + meterData.views
             + " out of " + meterData.maxViews
             + " free articles.";
        console.log('%cPugpig Piano Meter', 'background: #222; color: #cccccc', message);

       var element = document.querySelector('#pp-subs-meter-expired')
       if (element) {
         element.innerText = message;
        }
    }]);
  }

  function setUserState() {
    tp.pianoId.isUserValid() ? setUserLoggedIn() : setUserLoggedOut()
     // If we have the My Account Div or Reset Password Div, show it
    showStandardElements()
  }

  function onRegistrationSuccess(data) {
    pushEventToDataLayer('registrationSuccess', data);
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'registrationSuccess', data);
  }

  function onCheckoutSelectTerm(data) {
    pushEventToDataLayer('checkoutSelectTerm', data);
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'checkoutSelectTerm', data);
  }

 function onCheckoutStateChange(data) {
    pushEventToDataLayer('checkoutStateChange', data);
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'checkoutStateChange', data);
  }


  function onShowOffer(data) {
    pushEventToDataLayer('showOffer', data);
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'showOffer', data);
  }

  function onStartCheckout(data) {
    pushEventToDataLayer('startCheckout', data);
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'startCheckout', data);
  }

  function onSubmitPayment(data) {
    pushEventToDataLayer('submitPayment', data);
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'submitPayment', data);
  }

  function onCheckoutComplete(data) {
    pushEventToDataLayer('onCheckoutComplete', data);
    document.body.dataset.checkoutComplete = true
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'checkoutComplete', data);
    setUserState();
  }

  function onCheckoutClosed(data) {
    pushEventToDataLayer('onCheckoutClosed', data);
    setUserState();
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'checkoutClosed', data);
  }

  function setUserLoggedOut() {
    document.body.dataset.loggedIn = false
    document.body.dataset.loggedOut = true
    document.body.dataset.hasAccess = false;
    document.body.dataset.checkoutComplete = false

    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'setUserLoggedOut');
  }

  function checkUserHasAccessToResource() {

    // returns an array
    var accessMetaResourceIds = document.querySelectorAll("meta[property='pugpig:access:piano:rid']");

    var accessResourceIds = [];

    if (accessMetaResourceIds) {

      for (var i = accessMetaResourceIds.length - 1; i >= 0; i--) {
        var resource_id = accessMetaResourceIds[i].getAttribute('content');
        accessResourceIds.push(resource_id);
      }

      console.log('%cPugpig Piano', 'background: #222; color: #FFB6C1', 'allowedResources: '+accessResourceIds.join(", "));

      var callback = function(response) {

        var userAccesses = [];

        for (var i = response.count - 1; i >= 0; i--) {
          var user_access_resource_id = response.data[i].resource.rid;
          console.log('%cPugpig Piano', 'background: #222; color: #add8e6', 'userAccessRid: '+user_access_resource_id);
          userAccesses.push(user_access_resource_id);
        }
          
        var hasAccess = accessResourceIds.some(rid => userAccesses.includes(rid));

        if (hasAccess) {
          console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'userHasAccess: user has access to one or more allowed resources. User granted access.');

        } else {
          console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'userHasAccess: does not have access to any allowed resources.');
        }

        setUserAccess(hasAccess);

      }

      tp.api.callApi("/access/list", {}, callback);

    } else {
        //if no resource ID is set, Access is true
        setUserAccess(true);
    }
  }

  function setUserAccess(access) {

    if (document.body.dataset.unknownAccess == "false" && document.body.dataset.hasAccess == "true") {
      console.log("User already granted access");
      return;
    }

    document.body.dataset.unknownAccess = false;
    document.body.dataset.hasAccess = access;

    if (typeof dataLayer !== 'undefined') {
      if (access) {
        dataLayer.push({'has_access': true});
        if (tp.pianoId.isUserValid()) {
          dataLayer.push({'pugpigAuthStatus': 'Active'});
          dataLayer.push({event: 'auth_status_updated'});
        }
      } else {
        if (tp.pianoId.isUserValid()) {
          dataLayer.push({'pugpigAuthStatus': 'Lapsed'});
          dataLayer.push({event: 'auth_status_updated'});
        }
      }
    }
  }

  function setUserLoggedIn() {
    document.body.dataset.loggedIn = true
    document.body.dataset.loggedOut = false
    document.body.dataset.unknownAccess = true;
    console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'setUserLoggedIn');

    // Check that a user has access to elements if they are protected by a certain resource ID
    checkUserHasAccessToResource();

    // This allows us to get the custom fields
    var params = {};
    var accessMetaForm = document.querySelector("meta[property='pugpig:access:piano:form']");
    if (accessMetaForm) {
      // We like to use ExtendedPropertiesFields
      var custom_form_id = accessMetaForm.getAttribute('content');
      console.log('%cPugpig Piano', 'background: #222; color: #bada55', 'Using form ' + custom_form_id);

      params.formName = custom_form_id;
    }
    tp.pianoId.loadExtendedUser(params)

  }

  function handlePianoState() {
    if(!tp.pianoId.isUserValid()) {
      return tp.pianoId.show({ loggedIn: setUserLoggedIn })
    }
    tp.pianoId.logout()
    setUserLoggedOut()
  }

  function showStandardElements() {
    if (tp.pianoId.isUserValid()) {
      var element = document.querySelector('#pp-subs-myaccount-modal')
      if (element) {
        console.log('%cPugpig Piano', 'background: #123; color: green', 'Show My Account');
        tp.myaccount.show({ displayMode: 'inline', containerSelector: '#pp-subs-myaccount-modal' })
      }
    }

    var element = document.querySelector('#pp-subs-restorepassword-modal')
    if (element) {
      console.log('%cPugpig Piano', 'background: yellow; color: green', 'Show Restore Password');
      tp.pianoId.show({ screen: 'restore', displayMode: 'inline', containerSelector: '#pp-subs-restorepassword-modal' });
    }
  }

  function attachEventListeners() {
    var elements = ['#pp-subs-login','#pp-subs-logout']
    for (var i = elements.length - 1; i >= 0; i--) {
      var element = document.querySelectorAll(elements[i])
      if (element && element.length > 0) {
        element.forEach(item => {
          item.addEventListener('click', function(e) {
            e.stopPropagation()
            handlePianoState()
          })
        })
      }
    }

  }

}

if(!pugpigInApp()) {
  if (typeof window.tp !== 'undefined') {
    PugpigSitePiano();
  } else {
    window._pugpig = window._pugpig || {};
    window._pugpig.siteSubsBlocked = true;
  }
}
